export default "__VITE_ASSET__CRzZbppI__"